<template>
  <control :label="$t('country')" :warning="warning">
    <autocomplete
      :disabled="true"
      :placeholder="$t('country')"
      :dataSource="dataSource"
      :defaultValue="defaultValue"
      :loading="loading"
      @select="onSelect"
      @search="onSearch"
      @clear="onClear"
      class="autocomplete"
    />
  </control>
</template>

<script>
import Autocomplete from '@/components/common/Autocomplete.vue';
import { getCountries } from '@/services/network/places';
import { SECTION_CODES } from '@/constants';
import updateMixin from '@/components/account/targetingInfo/updateMixin';
import Control from '@/components/account/targetingInfo/Control.vue';

export default {
  mixins: [updateMixin(SECTION_CODES.COUNTRY)],
  components: {
    Autocomplete,
    Control,
  },
  data() {
    return {
      dataSource: [],
      countries: [],
      loading: false,
    };
  },
  watch: {
    countries(value) {
      this.dataSource = value.map(this.countryToOption);
    },
  },
  computed: {
    defaultValue() {
      return this.modelValue?.countryName;
    },
  },
  methods: {
    onSelect(value) {
      const id = Number(value);
      const country = this.countries.find(c => c.geonameId === id);
      this.onValueChange(country);
    },
    onSearch(searchText) {
      this.loading = true;
      getCountries(searchText)
        .then(countries => {
          this.countries = countries;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClear() {
      this.dataSource = [];
      this.onValueChange(null);
    },
    countryToOption(country) {
      return {
        text: country.countryName,
        value: country.geonameId.toString(),
      };
    },
  },
};
</script>
